import { FC } from "react";

const Car: FC = () => {
    return (
        <>
            <div className="fs-16 fw-700 text-black">Car</div>
            <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M23.65 6.2625C23.4 5.525 22.7 5 21.875 5H8.125C7.3 5 6.6125 5.525 6.35 6.2625L3.75 13.75V23.75C3.75 24.4375 4.3125 25 5 25H6.25C6.9375 25 7.5 24.4375 7.5 23.75V22.5H22.5V23.75C22.5 24.4375 23.0625 25 23.75 25H25C25.6875 25 26.25 24.4375 26.25 23.75V13.75L23.65 6.2625ZM8.5625 7.5H21.425L22.775 11.3875H7.2125L8.5625 7.5ZM23.75 20H6.25V13.75H23.75V20Z"
                fill="black"
                />
                <path
                d="M9.375 18.75C10.4105 18.75 11.25 17.9105 11.25 16.875C11.25 15.8395 10.4105 15 9.375 15C8.33947 15 7.5 15.8395 7.5 16.875C7.5 17.9105 8.33947 18.75 9.375 18.75Z"
                fill="black"
                />
                <path
                d="M20.625 18.75C21.6605 18.75 22.5 17.9105 22.5 16.875C22.5 15.8395 21.6605 15 20.625 15C19.5895 15 18.75 15.8395 18.75 16.875C18.75 17.9105 19.5895 18.75 20.625 18.75Z"
                fill="black"
                />
            </svg>
        </>
    )
}

export default Car;